"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var ie_banner_caution_svg_1 = __importDefault(require("@assets/components/app/base-layout/ie-banner-caution.svg"));
var Banner_1 = __importDefault(require("./widgets/Banner"));
var BANNER_TEXT = 'Go.gov.kh is not supported on Internet Explorer. Some features may not work correctly.';
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        icon: {
            marginRight: 6.67,
        },
    });
});
function BannerForIE(_a) {
    var isSticky = _a.isSticky;
    var classes = useStyles();
    var icon = (react_1.default.createElement("img", { className: classes.icon, src: ie_banner_caution_svg_1.default, draggable: false, alt: "caution logo" }));
    return react_1.default.createElement(Banner_1.default, { icon: icon, text: BANNER_TEXT, isSticky: isSticky });
}
exports.default = BannerForIE;
